import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 1023px) {
    padding: 12px 24px;
  }

  @media (min-width: 1024px) {
    padding: 24px 80px;
  }
`;

export const Logo = styled.img`
  flex-shrink: 0;

  @media (max-width: 1023px) {
    width: 80px;
  }

  @media (min-width: 1024px) {
    width: 96px;
  }
`;
